import { createFileRoute } from "@tanstack/react-router";
import { NotFound } from "@/components/app/shell/not-found";

/** A mistyped address inside the app: the router would otherwise answer from the root, above the
 * layout, on a blank page. Public addresses have their own routes, matched first. */
export const Route = createFileRoute("/_authenticated/$")({
  component: NotFound,
});
